/** Strings shared across features: the shell, errors, and generic actions (doc 05). */
export const commonCopy = {
  appName: 'Gift Group',

  nav: {
    home: 'Home',
    calendar: 'Calendar',
    shopping: 'Shopping',
    /** The badge's accessible name, so a screen reader hears a sentence, not a number. */
    shoppingBadge: (n: number) => (n === 1 ? '1 gift to buy' : `${n} gifts to buy`),
    ideas: 'Ideas',
    wishlist: 'Wishlist',
    family: 'Family',
    main: 'Main',
    skipToContent: 'Skip to content',
    notifications: 'Notifications',
    account: 'Account',
  },

  account: {
    settings: 'Settings',
    /** The bottom bar gave its Family tab to Wishlist (doc 15), so Family lives here. */
    family: 'Family',
    switchFamily: 'Switch family',
    joinAnother: 'Join another family',
    theme: 'Theme',
    signOut: 'Sign out',
  },

  actions: {
    save: 'Save',
    cancel: 'Cancel',
    back: 'Back',
    retry: 'Try again',
    close: 'Close',
    done: 'Done',
    /** Every toast that can be taken back uses this one word (doc 09, M14). */
    undo: 'Undo',
  },

  error: {
    heading: 'Well, that didn’t wrap up nicely.',
    body: 'Something went wrong on our end.',
    action: 'Try again',
  },

  notFound: {
    heading: 'This one’s not under the tree.',
    body: 'We couldn’t find that page. It may have been deleted, or the link might be off.',
    action: 'Take me home',
  },

  offline: 'You’re offline. We’ll pick up where you left off when you’re back.',

  loading: 'Loading…',

  home: {
    emptyTitle: 'Your calendar’s looking a little lonely',
    emptyBody:
      'Occasions, wishlists and claiming are on their way. For now, get everyone into the family.',
    emptyAction: 'See who’s here',
  },

  legal: { privacy: 'Privacy', terms: 'Terms' },
} as const;
